export const environment = {
  env: 'test',
  production: true,
  apiBaseUrl: 'https://bizlab-flow-test.azurewebsites.net'
};
